import {FTUETrainerTextProps} from '@skillz/ui';
import SKZConstants from 'SKZConstants';
import {_m} from 'INTL';
import GameOperationsTrainerBase from './GameOperationsTrainerBase';
import {BUBBLE_ANIMATION} from './GameOperationsTrainerBase.config';

export default class GameOperationsTrainerStepButtons
  extends GameOperationsTrainerBase
  implements FTUETrainerTextProps
{
  constructor() {
    super(SKZConstants.ETrainerAssetKey.FaceRight);
    this.text = _m("We've added some quick access icons for you!\nPlay on and enjoy the game!");
    this.overlayVisible = false;
    this.bubbleAnimation = BUBBLE_ANIMATION;
  }
}
